import React, { useState } from 'react';
import { PlayCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import ExtractQuarterlyPricesModal from './modals/ExtractQuarterlyPricesModal';

interface ExtractQuarterlyPricesButtonProps {
  slug: string;
  subslug?: string | null;
  variant?: "default" | "outline" | "secondary" | "ghost" | "link" | "destructive";
  size?: "default" | "sm" | "lg" | "icon";
  className?: string;
}

const ExtractQuarterlyPricesButton: React.FC<ExtractQuarterlyPricesButtonProps> = ({
  slug,
  subslug,
  variant = "default",
  size = "sm",
  className = ""
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant={variant}
              size={size}
              className={className}
              onClick={() => setIsModalOpen(true)}
            >
              <PlayCircle className="h-4 w-4 mr-2" />
              Run Extracts
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Extract pricing data for selected quarterly versions</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <ExtractQuarterlyPricesModal
        isOpen={isModalOpen}
        onOpenChange={setIsModalOpen}
        slug={slug}
        subslug={subslug}
      />
    </>
  );
};

export default ExtractQuarterlyPricesButton;
